var _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIxamee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "#fff",
      display: "block"
    },
    width: "294px",
    height: "294px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 50,
    textAnchor: "middle",
    dy: "0.38em",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#1b8392",
    strokeWidth: 0.6000000000000001,
    fontSize: 24,
    fontFamily: "arial"
  }, "\n  ixamee\n  ", /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "2.380952380952381s",
    values: "0 100;100 100;0 100",
    keyTimes: "0;0.5;1",
    keySplines: "0.3 0 0.7 1;0.3 0 0.7 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    repeatCount: "indefinite",
    dur: "2.380952380952381s",
    values: "0;0;-100",
    keyTimes: "0;0.5;1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIxamee);
export default __webpack_public_path__ + "static/media/ixamee.55a65607d0346e9eb3a21f5725dbce94.svg";
export { ForwardRef as ReactComponent };